import {OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {AutoUnsubscribe} from '../../../../decorators/auto-unsubscribe.decorator';
import {GoogleTagManagerService} from 'angular-google-tag-manager';
import {TrackingService} from '../../../../services/tracking.service';
import {SUBSCRIPTIONS} from 'src/app/common/utils/constants';
import {MenuItem} from '../navigation/menu-items';
import {AmplitudeService} from '../../../../services/amplitude.service';

@AutoUnsubscribe()
export abstract class MenuBase implements OnInit {
  public currentRoute: string = '';
  public showTooltip: boolean = false;

  constructor(
    protected readonly router: Router,
    protected readonly gtmService: GoogleTagManagerService,
    protected readonly trackingService: TrackingService,
    protected readonly ampliService: AmplitudeService,
  ) {}

  menuItemClick(menuItem: MenuItem) {
    const {gtmEvent, amplitudeEventInstance} = menuItem;
    this.gtmService.pushTag({
      event: gtmEvent,
      gtm_trigger: 'true',
    });
    this.trackingService.trackEvent({
      event: gtmEvent,
    });
    if (amplitudeEventInstance) {
      this.ampliService.track(amplitudeEventInstance);
    }
  }

  ngOnInit(): void {
    this.currentRoute = this.router.url;
    this[SUBSCRIPTIONS].add(
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        this.currentRoute = event.url;
      }),
    );
  }
}
